
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              PM不動産
            </Link>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <Link to="/search" className="text-gray-700 hover:text-blue-600 transition-colors duration-300 cursor-pointer">
              物件検索
            </Link>
            <Link to="/services" className="text-gray-700 hover:text-blue-600 transition-colors duration-300 cursor-pointer">
              サービス
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors duration-300 cursor-pointer">
              会社案内
            </Link>
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <button className="text-gray-700 hover:text-blue-600 transition-colors duration-300 cursor-pointer">
              <i className="ri-phone-line text-xl"></i>
            </button>
            <Link 
              to="/contact"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>

          <button 
            className="md:hidden text-gray-700 hover:text-blue-600 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <Link 
                to="/search" 
                className="text-gray-700 hover:text-blue-600 transition-colors duration-300 cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                物件検索
              </Link>
              <Link 
                to="/services" 
                className="text-gray-700 hover:text-blue-600 transition-colors duration-300 cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                サービス
              </Link>
              <Link 
                to="/about" 
                className="text-gray-700 hover:text-blue-600 transition-colors duration-300 cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                会社案内
              </Link>
              <Link 
                to="/contact"
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer w-fit"
                onClick={() => setIsMenuOpen(false)}
              >
                お問い合わせ
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
